/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="83.82"
        height="92.39"
        viewBox="0 0 83.82 92.39"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#0e497b"
          d="M27.36 81.77v10.62h-2.5V81.77h2.5z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M17.35 92.4Z"
          className="icon-fill icon-base"
          fillRule="evenodd"/>
        <path
          fill="#0e497b"
          d="M18.6 81.77v10.62h-2.5V81.77h2.5z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M17.35 81.77Z"
          className="icon-fill icon-base"
          fillRule="evenodd"/>
        <path
          fill="#0e497b"
          d="M17.35 59.91a1.24 1.24 0 0 1 1.24 1.14v20.74a1.25 1.25 0 0 1-2.49.13V61.16a1.25 1.25 0 0 1 1.25-1.25Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M8.59 92.4Z"
          className="icon-fill icon-base"
          fillRule="evenodd"/>
        <path
          fill="#0e497b"
          d="M9.84 81.77v10.62h-2.5V81.77h2.5z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M8.59 81.77Z"
          className="icon-fill icon-base"
          fillRule="evenodd"/>
        <path
          fill="#0e497b"
          d="M8.59 40.05a1.26 1.26 0 0 1 1.25 1.13v40.61a1.25 1.25 0 0 1-2.49.13V41.28a1.25 1.25 0 0 1 1.24-1.23Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M46.53 92.4Z"
          className="icon-fill icon-base"
          fillRule="evenodd"/>
        <path
          fill="#0e497b"
          d="M47.76 81.77v10.62h-2.5V81.77h2.5zM17.36 4.37a9.25 9.25 0 1 0 9.24 9.25 9.25 9.25 0 0 0-9.24-9.25Zm0 2.5a6.75 6.75 0 1 1-6.75 6.75 6.75 6.75 0 0 1 6.75-6.75Z"
          className="icon-fill icon-base"/>
        <path
          fill="none"
          d="M.03 92.39h83.74V.03H.03v92.36z"/>
        <path
          fill="#ffb81c"
          d="M65.64 2.85H45.27v17.08h20.37Zm-2.5 2.5v12.08H47.77V5.35Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M64.39 6.25h19.44l-8.2 8.54 8.2 8.54H59.37v-4.65h2.5v2.15h16.09l-5.79-6.04 5.79-6.04H64.39v-2.5z"
          className="icon-fill icon-accent"/>
        <path
          fill="#0e497b"
          d="M47.08 25.65a4.94 4.94 0 0 1 .22 9.87H27.36v46.25a1.25 1.25 0 0 1-1.12 1.28h-.12a1.26 1.26 0 0 1-1.25-1.12V34.27a1.25 1.25 0 0 1 1.12-1.22h21.09a2.431 2.431 0 0 0 .16-4.86H10.72a8.21 8.21 0 0 0-8.21 8v22.57a1.2 1.2 0 0 0 1.08 1.2h5a1.25 1.25 0 0 1 .13 2.49h-5a3.71 3.71 0 0 1-3.71-3.52V36.36a10.72 10.72 0 0 1 10.42-10.71h36.65Z"
          className="icon-fill icon-base"/>
        <path
          fill="none"
          d="M46.51 34.27v47.5"/>
        <path
          fill="#0e497b"
          d="M46.53 33.05a1.25 1.25 0 0 1 1.24 1.12V81.8a1.252 1.252 0 0 1-2.5.13V34.27a1.25 1.25 0 0 1 1.26-1.22Z"
          className="icon-fill icon-base"/>
        <path
          fill="none"
          d="M46.51 1.25V26.9"/><path
          fill="#0e497b"
          d="M46.53.05a1.25 1.25 0 0 1 1.24 1.13V26.9a1.252 1.252 0 0 1-2.5.13V1.25a1.25 1.25 0 0 1 1.26-1.2Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'PersonHoldingGroundedFlagIcon';

export default Icon;
